export const ITEM_TYPE = {
  TODO: {
    id: 'todo',
    title: 'Todo'
  },
  PROJECT: {
    id: 'project',
    title: 'Project'
  },
  AREA: {
    id: 'area',
    title: 'Area'
  },
  ATTACHMENT: {
    id: 'attachment',
    title: 'Attachment'
  }
}
